import { Injectable, Inject } from 'ng-metadata/core';
import {IGeneralAlertMsg} from "../../../infra/widgets/alerts/alertMsg.interface";
import {ALERT_MSG_TYPE, AlertFactory} from "../../../infra/widgets/alerts/alertFactory.service";

@Injectable()
export class NgrsService {
    
    public item:Object;
    private _signInLink: IGeneralAlertMsg;
    private _signInLinkRequest: IGeneralAlertMsg;
    private _showBestOffer: boolean = true;
    private _supplyTime: number = 0;
    private _loanPeriod: number = 0;

    
	constructor (private alertFactory :AlertFactory,) {
        this.initSignInLink();
        this.initSignInLinkRequest();
    }

    private initSignInLink(){
        this._signInLink = this.alertFactory.create(ALERT_MSG_TYPE.REQUEST) as IGeneralAlertMsg;
        let html =
        '<span class="bar-text margin-right-small" translate="nui.ngrs.signin"></span>' +
        '<prm-authentication [is-logged-in]="ctrl.isSignedIn()" flex="none"></prm-authentication>';

        this._signInLink.show(html);
    }

    private initSignInLinkRequest(){
        this._signInLinkRequest = this.alertFactory.create(ALERT_MSG_TYPE.REQUEST) as IGeneralAlertMsg;
        let html =
        '<span class="bar-text margin-right-small" translate="nui.ngrs.get.it.request.signin"></span>' +
        '<prm-authentication [is-logged-in]="ctrl.isSignedIn()" flex="none"></prm-authentication>';

        this._signInLinkRequest.show(html);
    }    

    get signInLink() {
        return this._signInLink;
    }

    set signInLink(value) {
        this._signInLink = value;
    }

    get signInLinkRequest() {
        return this._signInLinkRequest;
    }

    set signInLinkRequest(value) {
        this._signInLinkRequest = value;
    }    



}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrs.service.ts